class Storage {
    getData(key) {
        let cookies = window.document.cookie.split(';');
        for (let i = 0, item = cookies[i]; item; item = cookies[++i]) {
            let [name, value] = item.split('=');
            if (key === name.trim()) {
                return unescape(value);
            }
        }
        return false;
    }

    setData(key, value, expires_in = 36000) {
        let expires = new Date();
        expires.setTime(expires.getTime() + expires_in * 1000);
        let cookieValue = `${key}=${escape(value)};expires=${expires.toGMTString()};`;
        window.document.cookie = cookieValue;
    }

    delData(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = this.getData(name);
        if (cval != null)
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }

    clean() {
        let cookies = document.cookie.split(';');
        if (cookies.length > 0) {
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                let eqPos = cookie.indexOf('=');
                let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;';
            }
        }
    }
}

export default new Storage();




// WEBPACK FOOTER //
// ./src/utils/cookie.js